// extracted by mini-css-extract-plugin
export default {"tupacGrid":"fp-z","tupacHeader":"gp-z","tupacHeader2":"hp-z","tupacMenu":"ip-z","tupacMenu2":"jp-z","tupacMain":"kp-z","tupacMain2":"lp-z"};